module.exports = __webpack_public_path__ + "static/javascript-15ebe49e61e6ee4eb43f4f7f6d43a6e2.svg";